import BasicToSmart from './BasicToSmart'

export default BasicToSmart
